<template>
  <div class="lp-modal-wrapper" style="font-size:12px">
    <div class="columns is-multiline">
      <div class="column is-6">
        <div class="flex space-between" style="margin-bottom: 24px">
          <div class="flex align-center">
            <span>검색결과</span>
            <span> {{ filteredCount }}</span>
            <span>개 <span style="color:#ccc"> / </span> 전체</span>
            <span> {{ allCount }}</span>
            <span>개</span>
          </div>
          <!-- 10개씩보기 -->
          <div class="control">
            <span class="select">
              <select v-model="filtered.page_length" @change="selPageLength">
                <option v-for="(it,idx) in pageLengthList" :key="'len-'+idx"
                        :value="it.value">{{ it.label }}</option>
              </select>
            </span>
          </div>
        </div>
        <!-- 테아블 -->
        <div class="columns is-multiline">
          <div class="column is-full" style="height: 500px; overflow-y: scroll;">
            <table class="table">
              <thead>
              <tr>
                <td>번호</td>
                <td>이미지</td>
                <td>상품명</td>
                <td>판매가</td>
                <td>품절여부</td>
                <td>선택</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="prod in tableItems">
                <td>{{ prod.id }}</td>
                <td><div style="text-align: center; display: inline-block;"
                         :style="imgField(prod.img)"></div></td>
                <td>{{ prod.name }}</td>
                <td>{{ prod.price.price | currency }}</td>
                <td>
                  <span v-if="prod.soldout">품절</span>
                  <span v-else>판매</span></td>
                <td><button class="button small" @click="clickProduct(prod)">선택</button></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 페이지 -->
        <div class="pagination-group">
          <div class="pagination-btn-prev" @click="prevPage">
            <i class="material-icons unselect" style="margin-top:5px">keyboard_arrow_left</i>
          </div>
          <div class="pagination-num"
               v-if="visiblePageNumber(n)"
               v-for="(n,idx) in filtered.total_page"
               :key="'page'+idx">
          <span
            class="unselect"
            :class="{ 'pagination-num-selected' : n===filtered.page_num, 'pagination-num-not-selected' : n!==filtered.page_num }"
            @click="changePage(n)" style="font-size:1.2rem">{{ n }}</span>
          </div>
          <div class="pagination-btn-next" @click="nextPage">
            <i class="material-icons unselect" style="margin-top:5px">keyboard_arrow_right</i>
          </div>
        </div>
      </div>

      <!-- 우측 -->
      <div class="column is-6">
        <table class="table">
          <thead>
          <tr>
            <td>이미지</td>
            <td>상품명</td>
            <td>수량</td>
            <td>판매가</td>
            <td>삭제</td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(purchase,idx) in purchase_product">
            <td><div style="text-align: center; display: inline-block;"
                     :style="imgField(purchase.img)"></div></td>
            <td>{{ purchase.name }}</td>
            <td>{{ purchase.quantity }}</td>
            <td>{{ purchase.total_price | currency }}</td>
            <td><button @click="deletePurchase(idx)">삭제</button></td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="flex justify-center" style="padding: 8px;width:100%">
        <button class="button half" @click="$emit('closeModal')">취소</button>
        <button class="button is-primary" style="margin-left: 8px" @click="saveData">선택완료</button>
      </div>
    </div>

    <!-- 팝업 -->
    <div v-if="visible" class="lp-modal-wrapper">
      <div :class="{'lp-outsider': visible===true}" @click="clickOutSide"></div>
      <div class="columns is-multiline" :class="{'lp-selectedProduct': visible===true}">
        <div class="column is-full">
          <div>상품 선택</div>
        </div>
        <div class="column is-full">
          <div class="flex align-center">
            <div style="text-align: center; display: inline-block;"
                 :style="imgField(selectedProduct.img)"></div>
            <div style="margin-left: 8px">
              <div>{{ selectedProduct.name }}</div>
              <div>{{ selectedProduct.delivery_price | currency }}</div>
            </div>
          </div>
          <!-- 상품 옵션인 경우 -->
          <div v-if="selectedProduct.enable_option">
            <!--<admin-form-item label="옵션 선택">
                  <span class="select">
                    <select @change="selectOption">
                      <option v-for="option in selectedProduct.selectors[0].options">{{ option.name }}</option>
                    </select>
                  </span>
            </admin-form-item>-->
            <div v-for="selector in selectedProduct.selectors">
              <div class="flex space-between align-center lp-option-background"
                   v-for="option in selector.options">
                <div>{{ option.name }}</div>
                <div class="flex align-center">
                  <div>
                    <input class="input product-short-input"
                           v-model="option.quantity"
                           @input="e=>setNumber(e, 'option_quantity', 3, option)"
                           type="number">
                  </div>
                  <div style="margin-left: 20px">{{ option.price | currency }}</div>
                </div>
              </div>
            </div>

            <div class="flex space-between align-center" style="margin-top: 12px">
              <div>총 금액 {{ totalPrice | currency }} </div>
              <button class="button half is-primary" @click="addOption">확인</button>
            </div>
          </div>
          <!-- 상품인 경우 -->
          <div v-else>
            <div class="flex space-between align-center lp-option-background">
              <div>{{ selectedProduct.name }}</div>
              <div class="flex align-center">
                <div>
                  <input class="input product-short-input"
                         v-model="selectedProduct.quantity"
                         @input="e=>setNumber(e, 'quantity', 3, '')"
                         type="number">
                </div>
                <div style="margin-left: 20px">{{ selectedProduct.price | currency }}</div>
              </div>
            </div>
            <div class="flex space-between align-center" style="margin-top: 12px">
              <div>총 금액 {{ totalPrice | currency }} </div>
              <button class="button half is-primary" @click="addProduct">확인</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import pageLengthStructure from '../../module/admin/pageLengthStructure'

  export default {
    components: {
      },
    data() {
      return {
        tableItems: [],
        pageLengthList: pageLengthStructure.common,
        allCount: 0,
        filteredCount: 0,
        filtered: {
          cur_page: 1,
          page_num:1,
          total_page:1,
          page_length: 10
        },
        selectedProduct: undefined,
        purchase_product: [],
        totalPrice: 0,
        visible:false
      }
    },
    created() {
      this.getProductList();
    },
    methods: {
      // 페이지 숫자 보임여부
      visiblePageNumber(n) {
        // 현재 선택된 페이지 + 9까지 보임
        if(this.filtered.page_num <= n && n <= this.filtered.page_num+9) return true;
        // 전체페이지 - 현재 페이지
        let cal_page = this.filtered.total_page - this.filtered.page_num
        if(cal_page < 5 && n >= this.filtered.total_page - 5) {
          return true
        }
        else return false;
      },
      saveData(){
        this.$emit('addProduct', this.purchase_product);
      },
      // 상품의 수량체크해서 추가
      addProduct(){
        if (parseInt(this.selectedProduct.quantity) > 0) {
          let data = {
            product_id: this.selectedProduct.id,
            option: [],
            name: this.selectedProduct.name,
            quantity: parseInt(this.selectedProduct.quantity),
            total_price: this.selectedProduct.price,
            img: this.selectedProduct.img,
            delivery_price: this.selectedProduct.delivery_price,
            partner_id: this.selectedProduct.partner_id,
            type: 0,
          }

          this.purchase_product.push(data);
        }
        // 선택 상품 닫기
        this.visible = false;
      },
      addOption(){
        let options = this.selectedProduct.selectors[0].options;
        for(let i=0; i<options.length; i++){
          if(parseInt(options[i].quantity) > 0){
            let data = {
              product_id: this.selectedProduct.id,
              option: [options[i].id],
              name: options[i].name,
              quantity: parseInt(options[i].quantity),
              total_price: options[i].price,
              img: this.selectedProduct.img,
              delivery_price: this.selectedProduct.delivery_price,
              partner_id: this.selectedProduct.partner_id,
              type: 1
            }
            this.purchase_product.push(data);
          }
        }
        this.visible = false;
      },
      // 상품 선택
      clickProduct(prod){
        let product = this.cloneItem(prod);
        let delivery_price = 0
        if (product.delivery_price) delivery_price = product.delivery_price;

        this.totalPrice = 0;
        this.selectedProduct = {};
        this.selectedProduct.name = product.name;
        this.selectedProduct.price = product.price.price;
        this.selectedProduct.id = product.id;
        this.selectedProduct.enable_option = product.enable_option;
        this.selectedProduct.quantity = 0;
        this.selectedProduct.img = product.img;
        this.selectedProduct.delivery_price = delivery_price;
        this.selectedProduct.partner_id = product.partner_id;
        if (product.enable_option){
          /*let options = product.selectors[0].options;
          for(let i =0; i<options.length; i++){
            options[i].selected = false;
            options[i].quantity = 0;
          }*/
          this.selectedProduct.selectors = product.selectors;
        }


        this.visible = true;
      },
      // 옵션 선택
      selectOption(e){
        let options = this.selectedProduct.selectors[0].options;
        for(let i=0; i<options.length; i++){
          if(options[i].name === e.target.value){
            options[i].selected = true;
          }

        }
      },
      setNumber(e, type, max_length, option){
        if (type === 'quantity') {
          if( e.target.value.length > max_length ){
            this.selectedProduct.quantity = e.target.value.substr(0,max_length);
            this.totalPrice = this.selectedProduct.price * parseInt(this.selectedProduct.quantity);
          }
          else {
            this.selectedProduct.quantity = e.target.value;
            this.totalPrice = this.selectedProduct.price * parseInt(this.selectedProduct.quantity);
          }
        }
        else if(type === 'option_quantity') {
          if( e.target.value.length > max_length ) {
            option.quantity = e.target.value.substr(0,max_length);
            this.getOptionPrice();
          }
          else {
            option.quantity = e.target.value;
            this.getOptionPrice();
          }
        }
      },
      getOptionPrice(){
        let options = this.selectedProduct.selectors[0].options
        let totalPrice = 0;
        for(let i=0; i<options.length; i++){
          totalPrice += options[i].price * parseInt(options[i].quantity);
        }
        this.totalPrice = totalPrice;
      },
      getProductList(){
        this.$axios.get(this.getUrl('product'), {
          params: this.filtered
        }).then(res=>{
          if(res.status === 200) {
            this.filtered.page_length = res.data.page_length;
            this.filtered.cur_page = res.data.cur_page;
            this.filtered.total_page = res.data.total_page;
            this.allCount = res.data.total_count;
            this.filteredCount = res.data.count;
            this.tableItems = res.data.data;
          }
        })
      },
      selPageLength(){
        this.getProductList();
      },
      changePage(num) {
        this.filtered.page_num = num;
        this.filtered.cur_page = num;
        this.getProductList();
      },
      prevPage() {
        if (this.filtered.page_num > 1) {
          this.filtered.page_num -= 1;
          this.getProductList();
        }
      },
      nextPage() {
        if (this.filtered.page_num < this.filtered.total_page) {
          this.filtered.page_num += 1;
          this.getProductList();
        }
      },
      deletePurchase(index){
        removeIndex(this.purchase_product, index);
      },
      clickOutSide(){
        this.visible = false;
      },
      imgField(img) {
        return 'background-image: url('+this.image(img)+');' +
          ' width: 60px; height: 60px; background-size: cover;' +
          ' background-position: center;';
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .pagination-group {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
  }

  .pagination-btn-prev
  .pagination-btn-next {
    display: inline-block;
    /*height: 25px;*/
  }

  .pagination-num {
    display: inline-block;
  }

  .pagination-btn-prev i
  .pagination-btn-next i {
    color: #18a4ed;
    margin: 4px;
    cursor: pointer;
  }

  .pagination-num {
    padding: 5px 8px;
    cursor: pointer;
    font-size: .9rem;
  }

  .pagination-num-selected {
    color: #18a4ed;
  }

  .pagination-num-not-selected {
    color: #666;
  }

  .product-short-input
    width 89px

  .lp-outsider
    position fixed
    left 0
    right 0
    bottom 0
    top 0
    background-color rgba(0,0,0, 0.3)
    z-index 10

  .lp-selectedProduct
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    z-index 1000
    background-color white

  .lp-option-background
    padding 8px
    background-color #eee
    border-bottom 1px solid #e0e0e0

  .lp-option-background:last-child
    border-bottom 1px solid $primary
</style>
